import {Pipe} from "@angular/core";
import {backLightingReplacer} from "../../utils";
import {IntBackLightingTemplate} from "../../types";
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({
  name: 'intBackLighting',
  pure: true
})
export class IntBackLightingPipe {

  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: string, tokens: Array<IntBackLightingTemplate> | null) {
   const validTokens = tokens?.filter(t => Boolean(t.token))
   return (validTokens || []).length === 0 ? value : this.sanitizer.bypassSecurityTrustHtml(backLightingReplacer(value, validTokens || []));
  }
}
